import { render, staticRenderFns } from "./FolderIcon.vue?vue&type=template&id=1b12c908&"
import script from "./FolderIcon.vue?vue&type=script&lang=js&"
export * from "./FolderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports